/**
 * ******************************************************************************
 * Copyright Innov'ATM all rights reserved. This software is the property of
 * Innov'ATM and may not be used in any manner except under a license agreement
 * signed with Innov'ATM.
 * *******************************************************************************
 */

import { getOidc } from 'contexts/OidcContext/OidcContext';

export function getDevRootUrl() {
    return (
        (localStorage && localStorage.getItem && localStorage.getItem('DEV_ROOT_API_URL')) ||
        import.meta.env.VITE_DEFAULT_ROOT_API_URL ||
        window.location.origin + (import.meta.env.VITE_DEFAULT_RELATIVE_API_URL || '')
    );
}

export { default as globalAxios } from 'axios';

export function useApiBasePath() {
    return getDevRootUrl();
}

export const useAuthorizationToken = async () => {
    const oidc = getOidc();
    return (await oidc).getTokens().accessToken;
};
export function useAuthQueryKey() {
    return '';
}
